(() => {
  // src/color-swatch.ts
  (() => {
    const findImageWrap = (swatchEl) => swatchEl.closest(
      ".product-card-generic__image-wrap, .product-card__image-wrap"
    );
    document.addEventListener("click", (e) => {
      const swatch = e.target.closest("[data-color-swatch]");
      if (!swatch) return;
      e.preventDefault();
      e.stopPropagation();
    });
    document.addEventListener("mouseover", (e) => {
      const swatch = e.target.closest("[data-color-swatch]");
      if (!swatch) return;
      const targetSrc = swatch.dataset.image;
      if (!targetSrc) return;
      const wrap = findImageWrap(swatch);
      if (!wrap) return;
      wrap.querySelectorAll("[data-color-swatch]").forEach((s) => s.classList.remove("color-swatch__item--selected"));
      swatch.classList.add("color-swatch__item--selected");
      const img = wrap.querySelector("img");
      if (img) img.src = targetSrc;
    });
  })();
})();
